import { proxyClientInstance } from "../../wrappers/client";

export const getTK20Authorization = (profileId) => {
    const getUrl = `/api/iam/v1/authorization/aclsAndRoles?subject=${profileId}&subjectType=profileId&resource=ams/login`;
    return proxyClientInstance.get(getUrl);
  };